module.exports = __webpack_public_path__ + "static/media/low_carb_hot_chocolate.45cd344e.jpg";